import { YStack } from 'tamagui'
import { SectionHeader, SectionHeaderSkeleton } from './SectionHeader'

export function Section({
  title,
  subtitle,
  children,
}: {
  title: string
  subtitle?: string
  children: React.ReactNode
}) {
  return (
    <YStack gap="$3">
      <SectionHeader title={title} subtitle={subtitle} />
      {children}
    </YStack>
  )
}

export function SectionSkeleton({ children }: { children: React.ReactNode }) {
  return (
    <YStack gap="$3">
      <SectionHeaderSkeleton />
      {children}
    </YStack>
  )
}
